// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as DeleteRouteImport } from './routes/delete'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as LangIndexRouteImport } from './routes/$lang.index'
import { Route as LangMethodologyRouteImport } from './routes/$lang.methodology'
import { Route as BestIndexRouteImport } from './routes/best.index'
import { Route as BestSlugRouteImport } from './routes/best.$slug'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as HowToIndexRouteImport } from './routes/how-to.index'
import { Route as HowToSlugRouteImport } from './routes/how-to.$slug'
import { Route as PCodeRouteImport } from './routes/p.$code'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as ScanIdRouteImport } from './routes/scan.$id'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as LangBestIndexRouteImport } from './routes/$lang.best.index'
import { Route as LangBestSlugRouteImport } from './routes/$lang.best.$slug'
import { Route as LangCompareIndexRouteImport } from './routes/$lang.compare.index'
import { Route as LangCompareSlugRouteImport } from './routes/$lang.compare.$slug'
import { Route as LangGlossaryIndexRouteImport } from './routes/$lang.glossary.index'
import { Route as LangGlossarySlugRouteImport } from './routes/$lang.glossary.$slug'
import { Route as LangHowToIndexRouteImport } from './routes/$lang.how-to.index'
import { Route as LangHowToSlugRouteImport } from './routes/$lang.how-to.$slug'
import { Route as LangToolsIndexRouteImport } from './routes/$lang.tools.index'
import { Route as LangToolsSlugRouteImport } from './routes/$lang.tools.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const DeleteRoute = DeleteRouteImport.update({
            id: '/delete',path: '/delete',getParentRoute: () => rootRouteImport
          })
const MethodologyRoute = MethodologyRouteImport.update({
            id: '/methodology',path: '/methodology',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/$lang/',path: '/$lang/',getParentRoute: () => rootRouteImport
          })
const LangMethodologyRoute = LangMethodologyRouteImport.update({
            id: '/$lang/methodology',path: '/$lang/methodology',getParentRoute: () => rootRouteImport
          })
const BestIndexRoute = BestIndexRouteImport.update({
            id: '/best/',path: '/best/',getParentRoute: () => rootRouteImport
          })
const BestSlugRoute = BestSlugRouteImport.update({
            id: '/best/$slug',path: '/best/$slug',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const HowToIndexRoute = HowToIndexRouteImport.update({
            id: '/how-to/',path: '/how-to/',getParentRoute: () => rootRouteImport
          })
const HowToSlugRoute = HowToSlugRouteImport.update({
            id: '/how-to/$slug',path: '/how-to/$slug',getParentRoute: () => rootRouteImport
          })
const PCodeRoute = PCodeRouteImport.update({
            id: '/p/$code',path: '/p/$code',getParentRoute: () => rootRouteImport
          })
const RCodeRoute = RCodeRouteImport.update({
            id: '/r/$code',path: '/r/$code',getParentRoute: () => rootRouteImport
          })
const ScanIdRoute = ScanIdRouteImport.update({
            id: '/scan/$id',path: '/scan/$id',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/tools/$slug',path: '/tools/$slug',getParentRoute: () => rootRouteImport
          })
const LangBestIndexRoute = LangBestIndexRouteImport.update({
            id: '/$lang/best/',path: '/$lang/best/',getParentRoute: () => rootRouteImport
          })
const LangBestSlugRoute = LangBestSlugRouteImport.update({
            id: '/$lang/best/$slug',path: '/$lang/best/$slug',getParentRoute: () => rootRouteImport
          })
const LangCompareIndexRoute = LangCompareIndexRouteImport.update({
            id: '/$lang/compare/',path: '/$lang/compare/',getParentRoute: () => rootRouteImport
          })
const LangCompareSlugRoute = LangCompareSlugRouteImport.update({
            id: '/$lang/compare/$slug',path: '/$lang/compare/$slug',getParentRoute: () => rootRouteImport
          })
const LangGlossaryIndexRoute = LangGlossaryIndexRouteImport.update({
            id: '/$lang/glossary/',path: '/$lang/glossary/',getParentRoute: () => rootRouteImport
          })
const LangGlossarySlugRoute = LangGlossarySlugRouteImport.update({
            id: '/$lang/glossary/$slug',path: '/$lang/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const LangHowToIndexRoute = LangHowToIndexRouteImport.update({
            id: '/$lang/how-to/',path: '/$lang/how-to/',getParentRoute: () => rootRouteImport
          })
const LangHowToSlugRoute = LangHowToSlugRouteImport.update({
            id: '/$lang/how-to/$slug',path: '/$lang/how-to/$slug',getParentRoute: () => rootRouteImport
          })
const LangToolsIndexRoute = LangToolsIndexRouteImport.update({
            id: '/$lang/tools/',path: '/$lang/tools/',getParentRoute: () => rootRouteImport
          })
const LangToolsSlugRoute = LangToolsSlugRouteImport.update({
            id: '/$lang/tools/$slug',path: '/$lang/tools/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,DeleteRoute: DeleteRoute,MethodologyRoute: MethodologyRoute,PrivacyRoute: PrivacyRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,LangMethodologyRoute: LangMethodologyRoute,BestSlugRoute: BestSlugRoute,CompareSlugRoute: CompareSlugRoute,GlossarySlugRoute: GlossarySlugRoute,HowToSlugRoute: HowToSlugRoute,PCodeRoute: PCodeRoute,RCodeRoute: RCodeRoute,ScanIdRoute: ScanIdRoute,ToolsSlugRoute: ToolsSlugRoute,LangIndexRoute: LangIndexRoute,BestIndexRoute: BestIndexRoute,CompareIndexRoute: CompareIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,HowToIndexRoute: HowToIndexRoute,ToolsIndexRoute: ToolsIndexRoute,LangBestSlugRoute: LangBestSlugRoute,LangCompareSlugRoute: LangCompareSlugRoute,LangGlossarySlugRoute: LangGlossarySlugRoute,LangHowToSlugRoute: LangHowToSlugRoute,LangToolsSlugRoute: LangToolsSlugRoute,LangBestIndexRoute: LangBestIndexRoute,LangCompareIndexRoute: LangCompareIndexRoute,LangGlossaryIndexRoute: LangGlossaryIndexRoute,LangHowToIndexRoute: LangHowToIndexRoute,LangToolsIndexRoute: LangToolsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)